const TOKEN = /(https?:\/\/[^\s<]+|www\.[^\s<]+|[\w.%+-]+@[\w-]+(?:\.[\w-]+)+)/g
const TRAILING = /[.,;:!?)\]}'"»]+$/
const OPEN_ANCHOR = /^<a[\s>]/i
const CLOSE_ANCHOR = /^<\/a\s*>/i

const toHref = (url: string) => {
  if (url.startsWith('http')) return url
  if (url.startsWith('www.')) return `https://${url}`
  return `mailto:${url}`
}

// ponytail: découpage sur `<...>` plutôt qu'un parseur DOM ; un `>` dans une valeur d'attribut casserait,
// ce que l'éditeur Quill du CMS ne produit pas.
export const linkify = (html: string) => {
  let insideAnchor = false

  return html
    .split(/(<[^>]*>)/)
    .map(part => {
      if (part.startsWith('<')) {
        if (OPEN_ANCHOR.test(part)) insideAnchor = true
        else if (CLOSE_ANCHOR.test(part)) insideAnchor = false
        return part
      }
      if (insideAnchor || !part) return part

      return part.replace(TOKEN, match => {
        const trailing = TRAILING.exec(match)?.[0] ?? ''
        const url = trailing ? match.slice(0, -trailing.length) : match
        return `<a href="${toHref(url)}">${url}</a>${trailing}`
      })
    })
    .join('')
}
